import React, {
 FC,
 useContext,
 useEffect,
 useMemo,
 useRef,
 useState,
} from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import BannerItem from "../components/Banners/BannerItem";
import Loading from "../components/UI/Loading/Loading";
import CopyMessage from "../components/UI/CopyMessage/CopyMessage";
import EditBannerModal from "../components/Banners/EditBannerModal";
import PopupModalConfrim from "../components/PopupBannerItem/PopupModalConfrim";
import BannersLinkRewriter from "../components/BannersLinkRewriter/BannersLinkRewriter";

interface Banner {
 title: string;
 _id: string;
 isActive: boolean;
 link: string;
 description: string;
 seoName: string;
 post: string;
}

const BannerList: FC = () => {
 const { postStore } = useContext(Context);
 const [page, setPage] = useState(1);
 const [totalPages, setTotalPages] = useState<number[]>([]);
 const [loading, setLoading] = useState<boolean>(true);
 const limit = 50;
 const parentRef = useRef<any>(null);
 const [isShowPopupConfirm, setIsShowPopupConfirm] = useState<boolean>(false);
 const [copied, setCopied] = useState(false);
 const [visibleEditModal, setVisibleEditModal] = useState<boolean>(false);
 const [activeEditListID, setActiveEditListID] = useState<string>("");

 const [openModalAgree, setOpenModalAgree] = useState<boolean>(false);


 useMemo(() => {
  const pagesArray = [];
  for (let i = 0; i < postStore.bannerPages; i++) {
   pagesArray.push(i + 1);
  }
  setTotalPages(pagesArray);
  return pagesArray;
 }, [postStore.bannerPages]);

 useEffect(() => {
  const fetchBanners = async () => {
   setLoading(true);
   try {
    await postStore.getBanners(page, limit);
   } catch (error) {
    console.error("Error fetching banners:", error);
   } finally {
    setLoading(false);
   }
  };

  fetchBanners();
 }, [page, postStore]);

 const handleClickPage = (i: number) => {
  setPage(i);
 };

 const openModalEdit = (id: string) => {
  setVisibleEditModal(!visibleEditModal);
  setActiveEditListID(id);
 };

 const filterItemList = () => {
  const post = postStore.banners.find((post) => post._id === activeEditListID);
  return (
   post ?? {
    _id: "",
    post: "",
    title: "",
    isActive: false,
    category: "",
    description: "",
    link: "",
    priority: "",
   }
  );
 };

 const selectedBanner = filterItemList();

 const deletBannerItem = () => {
  setIsShowPopupConfirm(false);
  const obj = Object({
   id: activeEditListID,
  });

  postStore.deleteBanner(obj).then(() => {
   setActiveEditListID("");
   postStore.getBanners(1, limit);
  });
 };

 return (
  <div>

   { openModalAgree ? <BannersLinkRewriter handleAgreement={setOpenModalAgree}/> : false }

   <div className="w-full h-1 bg-slate-400 rounded-md"></div>
   <div>
    <div className='d-flex justify-content-between'>
     <h6>Banners List</h6>
     <button className='btn btn-secondary' onClick={() => setOpenModalAgree(true)}>Change all links</button>
    </div>

    <hr />
    <div className="card">
     <div className="card-body">
      {loading ? (
       <Loading />
      ) : (
       <table className="table mb-0 table-dark table-striped">
        <thead>
         <tr>
          <th scope="col">#</th>
          <th style={{ width: "130px!important" }} scope="col">
           Main Img
          </th>
          <th scope="col">Title</th>
          <th scope="col">
           P
          </th>
          <th scope="col"></th>
          <th scope="col"></th>
         </tr>
        </thead>
        <tbody ref={parentRef}>
         {postStore.banners.map((e, i) => (
          <BannerItem
           title={e.title}
           priority={e.priority}
           id={e._id}
           seoName={e.seoName}
           isActive={e.isActive}
           description={e.description}
           post={e.post}
           link={e.link}
           key={i}
           mainImg={e.mainImg}
           setCopied={(e) => setCopied(e)}
           openModalEdit={openModalEdit}
           actionShowPopupConfirm={(e) => {
            setIsShowPopupConfirm(e);
           }}
           setActiveEditListID={(id) => {
            setActiveEditListID(id);
           }}
          />
         ))}
        </tbody>
       </table>
      )}
      <nav aria-label="...">
       <ul className="pagination mt-3">
        <li className="page-item">
         <span className="page-link" style={{ color: "#12181a" }}>
          i
         </span>
        </li>
        {totalPages.map((e, i) => (
         <li key={i} className="page-item">
          <button
           onClick={() => handleClickPage(i + 1)}
           className={page === i + 1 ? "page-link bg-secondary" : "page-link"}
          >
           {i + 1}
          </button>
         </li>
        ))}
        <li className="page-item">
         <span className="page-link" style={{ color: "#12181a" }}>
          i
         </span>
        </li>
       </ul>
      </nav>
     </div>
    </div>
   </div>
   {copied && <CopyMessage />}
   {visibleEditModal && activeEditListID !== "" && (
    <EditBannerModal
     bannerId={selectedBanner._id}
     post={selectedBanner.post}
     title={selectedBanner.title}
     isActive={selectedBanner.isActive}
     description={selectedBanner.description}
     link={selectedBanner.link}
     priority={selectedBanner.priority}
     handlePopUpOpen={(e) => {
      document.body.style.overflow = "auto";
      openModalEdit(e);
     }}
    />
   )}
   {isShowPopupConfirm && (
    <PopupModalConfrim
     actionShowPopup={(status) => {
      status ? deletBannerItem() : setIsShowPopupConfirm(false);
      document.body.style.overflow = "auto";
     }}
    />
   )}
  </div>
 );
};

export default observer(BannerList);
